// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"e5541ea7","938":"66159e9d"}[chunkId] + ".chunk.css";
};